<app-pageheader [Parent]="this">
</app-pageheader>
<app-loader [Parent]="this"></app-loader>

<div class="columns">
  <div class="column is-half">
    <p>Total to Reconcile: {{TotalToReconcile ?? "--"}}</p>
  </div>
</div>

@if (ActionItems.length > 0) {
  <table class="table is-fullwidth">
    <thead>
      <tr>
        <th class="column-half">Imported</th>
        <th class="icon-cell"></th>
        <th class="column-half">FrogOne</th>
      </tr>
    </thead>
    <tbody>
      @for (item of ActionItems; track item) {
        <tr>
          <td class="column-half">
            <article class="panel">
              <p class="panel-heading">Transaction {{item.ImportedCard.TransactionId}}
                (<a href="/revenue/reconciliation/statements/{{item.ImportedCard.ProviderStatementId}}" target="_blank">Statement {{item.ImportedCard.ProviderStatementId}}</a>)
              </p>
              @for (field of item.ImportedCard.DisplayFields | keyvalue; track field) {
                <p class="panel-block">
                  <span class="label">{{field.key}}</span>
                  <span class="value">{{field.value}}</span>
                </p>
              }
              <p class="panel-block">
                <span class="has-text-centered" style="width:100%">
                  <button class="button is-small is-warning is-right" (click)="ignoreIssue(item.ImportedCard.ProviderStatementRowId, item.ImportedCard.ProviderStatementId)">
                    <i class="fa-regular fa-xmark-to-slot" style="padding-right: 0.5rem;"></i>
                    Ignore
                  </button>
                </span>
              </p>
            </article>
          </td>
          <td class="icon-cell">
            <i class="fa fa-chevron-right"></i>
          </td>
          @if (item.FrogOneCards.length > 0) {
            <td class="column-half">
              @for (card of item.FrogOneCards; track card; let i = $index) {
                <div [ngClass]="{ 'mb-4': item.FrogOneCards.length > 1  && i != item.FrogOneCards.length-1}">
                  @if (card.CardType == 'nodetails') {
                    <article class="panel">
                      <p class="panel-heading">Possible Resolutions</p>
                      <p class="panel-block">
                        <span class="label">&nbsp;</span>
                        <span class="value">&nbsp;</span>
                      </p>
                      <p class="panel-block">
                        <span class="label">&nbsp;</span>
                        <span class="value">&nbsp;</span>
                      </p>
                      <p class="panel-block">
                        <span class="has-text-centered" style="width:100%">
                          @for (a of card.Actions; track a) {
                            <button class="button is-small mr-2 is-{{a.ButtonColor}}" (click)="doAction(a)" >
                              @if (a.IconName != null) {
                                <i class="fa-regular fa-{{a.IconName}}" style="padding-right: 0.75rem;"></i>
                              }
                              {{a.DisplayName}}
                            </button>
                          }
                        </span>
                      </p>
                      <p class="panel-block">
                        <span class="label">&nbsp;</span>
                        <span class="value">&nbsp;</span>
                      </p>
                      <p class="panel-block">
                        <span class="label">&nbsp;</span>
                        <span class="value">&nbsp;</span>
                      </p>
                    </article>
                  }
                  @if (card.CardType == 'build') {
                    <article class="panel">
                      @if (card.HeaderUrl == null) {
                        <p class="panel-heading">{{card.CardName ?? "Resolution details"}}</p>
                      }
                      @if (card.HeaderUrl != null) {
                        <p class="panel-heading"><a [href]="card.HeaderUrl" target="_blank">{{card.CardName ?? "Resolution details"}}</a></p>
                      }
                      @for (field of card.DisplayFields | keyvalue; track field) {
                        <p class="panel-block">
                          <span class="label">{{field.key}}</span>
                          <span class="value">{{field.value}}</span>
                        </p>
                      }
                      @if (card.Table != null) {
                        <span class="panel-block">
                          <table class="cardTable">
                            <thead>
                              <tr>
                                @for (h of card.Table.Headers; track h) {
                                  <th>{{h?.Value ?? ""}}</th>
                                }
                                <th></th>
                              </tr>
                            </thead>
                            @for (row of card.Table.Rows; track row) {
                              <tr>
                                @for (col of row.Columns; track col) {
                                  <td>{{col?.Value ?? ""}}</td>
                                }
                                <td>
                                  @if (row.Actions != null) {
                                    <span>
                                      @for (act of row.Actions; track act) {
                                        <button class="button mr-1 is-small is-{{act.ButtonColor}}" (click)="doAction(act)">
                                          @if (act.IconName != null) {
                                            <i class="fa-regular fa-{{act.IconName}}" style="padding-right: 0.75rem;"></i>
                                          }
                                          {{act.DisplayName}}
                                        </button>
                                      }
                                    </span>
                                  }
                                </td>
                              </tr>
                            }
                          </table>
                        </span>
                      }
                      <p class="panel-block">
                        <span class="has-text-centered" style="width:100%">
                          @for (a of card.Actions; track a) {
                            <button class="button mr-2 mb-2 is-small is-{{a.ButtonColor}}" (click)="doAction(a)" >
                              @if (a.IconName != null) {
                                <i class="fa-regular fa-{{a.IconName}}" style="padding-right: 0.75rem;"></i>
                              }
                              {{a.DisplayName}}
                            </button>
                          }
                        </span>
                      </p>
                    </article>
                  }
                  @if (card.CreateAction != null) {
                    <article class="panel" style="border-style: dashed; border-color: lightgrey;">
                      <p class="panel-block">
                        <span class="has-text-centered" style="width:100%; vertical-align: middle;">
                          <button class="button is-small is-{{card.CreateAction.ButtonColor}}" (click)="doAction(card.CreateAction)" >
                            @if (card.CreateAction.IconName != null) {
                              <i class="fa-regular fa-{{card.CreateAction.IconName}}" style="padding-right: 0.75rem;"></i>
                            }
                            {{card.CreateAction.DisplayName}}
                          </button>
                        </span>
                      </p>
                    </article>
                  }
                </div>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
}
